/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* BLU-37: dynamic price near Add to Cart, TagFit size guide inline with "Size", mobile padding, text-only elegant USP.
   SCOPE: this block is limited to the DEFAULT product template only (data-template-name="product" and no suffix),
   so the restyle never leaks onto other product templates (e.g. digital-downloads, quick-view, box, zeno, ...). */
(function () {
  if (window.__blu37Init) return;
  window.__blu37Init = true;

  function bluIsDefaultProduct() {
    var b = document.body;
    if (!b) return false;
    return b.getAttribute('data-template-name') === 'product' && (b.getAttribute('data-template-suffix') || '') === '';
  }
  if (!bluIsDefaultProduct()) return;

  var doc = document;

  /* ---- Money formatter mirroring Shopify money_format (€{{amount_with_comma_separator}}) ---- */
  function bluMoney(cents) {
    if (cents === null || cents === undefined) return '';
    var s = (cents / 100).toFixed(2);
    var p = s.split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var amount = p.join(',');
    var fmt = (window.Shopify && window.Shopify.money_format) || '€{{amount_with_comma_separator}}';
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, p[0].replace(/\./g, ','))
      .replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  }

  /* ---- Keep the price block right above Add to Cart in sync on variant change ---- */
  function bluApplyPrice(v) {
    if (!v) return;
    var el = doc.querySelector('.blu-price--cta');
    if (!el) return;
    var list = el.querySelector('[data-product-price-list], .price-list');
    if (!list) return;
    var price = v.price, compare = v.compare_at_price;
    var save = el.querySelector('.blu-price__save');
    if (compare && compare > price) {
      list.innerHTML = '<span class="price price--highlight">' + bluMoney(price) + '</span>' +
                       '<span class="price price--compare">' + bluMoney(compare) + '</span>';
      if (save) save.textContent = 'Save ' + Math.round((compare - price) / compare * 100) + '%';
    } else {
      list.innerHTML = '<span class="price">' + bluMoney(price) + '</span>';
      if (save) save.parentNode.removeChild(save);
    }
  }
  function bluSyncPrice() {
    var s = doc.querySelector('form.product-form script[data-variant]');
    if (s) { try { bluApplyPrice(JSON.parse(s.textContent)); } catch (e) {} }
  }

  /* ---- Spot a TagFit "Size guide" link inline with the "Size"/"Taglia" label ----
     We keep the original button inside TagFit's root (so its click still opens the modal)
     but make it invisible, and render a lean "Size guide" link next to the Size label
     that triggers the original button.
     NOTE: this routine is idempotent and re-runs after the section re-render on variant
     change (which otherwise wipes our injected link away). */
  function bluPlaceSizeGuide() {
    var btns = doc.querySelectorAll('[data-sizechart-root] .sizechart-button');
    var variants = doc.querySelectorAll('.product-form__variants');
    for (var b = 0; b < btns.length; b++) {
      var btn = btns[b];
      var sizeOpt = null;
      for (var v = 0; v < variants.length && !sizeOpt; v++) {
        var opts = variants[v].querySelectorAll('.product-form__option');
        for (var i = 0; i < opts.length; i++) {
          var nm = opts[i].querySelector('.product-form__option-name');
          if (nm && /^(size|taglia)\b/i.test((nm.textContent || '').trim().split(':')[0].trim())) { sizeOpt = opts[i]; break; }
        }
      }
      var nameLine = sizeOpt ? sizeOpt.querySelector('.product-form__option-name') : null;
      if (!nameLine) continue;

      /* always hide the original (it stays in TagFit's root for modal delegation) + hide its empty app block box */
      btn.style.cssText = 'display:none !important;';
      var appBlock = btn.closest('.product-info__block-item');
      if (appBlock) appBlock.style.display = 'none';

      /* ensure a wrap exists around the Size label (anchor on sizeOpt so we never re-nest) */
      var wrap = sizeOpt.querySelector('.blu-size-name');
      if (!wrap) {
        wrap = doc.createElement('span');
        wrap.className = 'blu-size-name';
        sizeOpt.insertBefore(wrap, nameLine);
      }
      if (!wrap.contains(nameLine)) wrap.appendChild(nameLine);

      /* ensure the visual link exists and re-point it at THIS button (survives re-render) */
      var visual = wrap.querySelector('.blu-sizechart-visual');
      if (!visual) {
        visual = doc.createElement('button');
        visual.type = 'button';
        visual.className = 'blu-sizechart-visual';
        visual.setAttribute('data-sizechart-open', '');
        visual.textContent = 'Size guide';
        wrap.appendChild(visual);
      }
      visual.onclick = function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        btn.click();
      };
    }
  }

  /* ---- Lean/smooth styles: mobile gutters for out-of-form blocks + text-only elegant USP ---- */
  function bluInjectStyles() {
    if (doc.getElementById('blu37-style')) return;
    var css =
      '@media (max-width: 999px){' +
        '.product-block-list__item--info .card--sticky > .product-info__block-item{padding-left:20px;padding-right:20px;}' +
      '}' +
      '.product-info__block-item--text ul{' +
        'list-style:none;margin:14px 0 4px;padding:0;display:block;background:none;border:0;border-radius:0;' +
      '}' +
      '.product-info__block-item--text ul li{' +
        'position:relative;display:block;padding:2px 0;font-size:15px;font-weight:600;line-height:1.5;' +
        "font-family:'Playfair Display','Georgia',Palatino,serif;color:var(--heading-color,#111);" +
      '}' +
      '.blu-size-name .blu-sizechart-visual{' +
        'display:inline;background:none;border:0;padding:0;margin-left:auto;box-shadow:none;' +
        'color:var(--heading-color,#111);font-size:13px;font-weight:600;text-decoration:underline;' +
        'text-underline-offset:3px;cursor:pointer;line-height:1.4;' +
      '}';
    var st = doc.createElement('style');
    st.id = 'blu37-style';
    st.textContent = css;
    doc.head.appendChild(st);
    var link = doc.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600&display=swap';
    link.media = 'print';
    if (link.addEventListener) link.addEventListener('load', function () { link.media = 'all'; });
    doc.head.appendChild(link);
  }

  function bluInit() {
    bluPlaceSizeGuide();
    bluSyncPrice();
  }

  bluInjectStyles();

  var placedTimer = null;
  var mo = new MutationObserver(function () {
    if (placedTimer) return;
    placedTimer = window.setTimeout(function () {
      placedTimer = null;
      bluInit();
    }, 150);
  });
  mo.observe(doc.body, { childList: true, subtree: true });

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', bluInit);
  } else {
    bluInit();
  }
  doc.addEventListener('variant:changed', function (e) { bluApplyPrice(e.detail && e.detail.variant); bluPlaceSizeGuide(); });
  doc.addEventListener('variant:change', function (e) { bluApplyPrice(e.detail && e.detail.variant); });
  doc.addEventListener('product:rerender', bluInit);
  doc.addEventListener('shopify:section:load', bluInit);
  setTimeout(bluInit, 1200);
})();


/**
 * BLU-110: PDP cross-sell widget (complementary_products block) measurement.
 * - CTR: pushes a GA4-style `select_item` event to window.dataLayer when a
 *   complementary product card (inside <product-recommendations intent="complementary">)
 *   is clicked (card link click or quick-buy submit).
 * - AOV attribution: the quick-buy form already tags the line item with
 *   properties[_cross_sell_source] = 'pdp_complementary_widget' (see product-item.liquid),
 *   which flows through to the order's line_items[].properties for ShopifyQL/Admin API
 *   attribution -- no further JS needed for that half.
 */
(function () {
  if (window.__blu110CrossSellTracking) return;
  window.__blu110CrossSellTracking = true;

  function bluPushDataLayer(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function bluCrossSellItemFromEl(el) {
    var card = el.closest('[data-cross-sell-item="true"]');
    if (!card) return null;
    var widget = el.closest('[data-cross-sell-widget]');
    return {
      item_id: card.getAttribute('data-product-id') || '',
      item_handle: card.getAttribute('data-product-handle') || '',
      price: card.getAttribute('data-product-price') || '',
      anchor_product_id: widget ? widget.getAttribute('data-anchor-product-id') || '' : '',
      anchor_product_handle: widget ? widget.getAttribute('data-anchor-product-handle') || '' : '',
      widget_name: widget ? widget.getAttribute('data-cross-sell-widget') || '' : ''
    };
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var card = target.closest('[data-cross-sell-item="true"]');
    if (!card) return;
    var linkOrButton = target.closest('a, button');
    if (!linkOrButton) return;
    var item = bluCrossSellItemFromEl(card);
    if (!item) return;
    bluPushDataLayer({
      event: 'select_item',
      item_list_name: 'pdp_complementary_widget',
      items: [item]
    });
  }, true);
})();
